// extracted by mini-css-extract-plugin
var _1 = "evw5K";
var _2 = "tn4FO";
var _3 = "drOQ3";
var _4 = "iimqz";
var _5 = "YwbuK elide";
export { _1 as "base", _2 as "delete", _3 as "error", _4 as "icon", _5 as "label" }
